import { render, staticRenderFns } from "./ClientTransactions.vue?vue&type=template&id=ca1ea530"
import script from "./ClientTransactions.vue?vue&type=script&lang=js"
export * from "./ClientTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports